module.exports = require("react-pubsub-via-radio.js/RadioMixin");



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/react-pubsub-via-radio.js/RadioMixin.js
// module id = 20
// module chunks = 0 1 2 3 4